import * as React from 'react';

import {
  Colors,
  Lang,
  Breakpoint,

  useDimensions,

  Text,
} from '@bluecurrent/web-component-lib';

import useGraphStore from '../../stores/useGraphStore';

import Bar from './Bar';

export default function Item({
  amount,
  hour,
  day,
  index,
  height,
  spacing,
  type,
  hasNegative,
  isNow,
  isToday,
}) {
  const { _ } = Lang.useTranslation();
  const size = useDimensions();

  const [isHover, setHover] = React.useState(false);

  const onPriceHover = useGraphStore((state) => state.onPriceHover);
  const onDateHover = useGraphStore((state) => state.onDateHover);
  const onTimeHover = useGraphStore((state) => state.onTimeHover);

  return (
    <div
      onMouseEnter={() => {
        if (amount === null) return;

        setHover(true);
        onPriceHover(amount);
        onDateHover(day);
        onTimeHover(hour);
      }}
      onMouseLeave={() => {
        setHover(false);
        onPriceHover(null);
        onDateHover(null);
        onTimeHover(null);
      }}
      style={{
        width: '100%',
        height: '100%',
        paddingTop: 22,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: hasNegative ? 'center' : 'flex-end',
        backgroundColor: (isHover || isNow)
          ? `${Colors.MEDIUM_WHITE}A6`
          : 'transparent',
        position: 'relative',
      }}
    >
      {
        isNow && (
          <div
            style={{
              position: 'absolute',
              top: 40,
              transform: 'rotate(-90deg)',
            }}
          >
            {
              size.width >= Breakpoint.md && (
                <Text
                  fontSize="1em"
                  fontWeight={100}
                  color="#CCCCCC"
                  textAlign="right"
                >
                  {_('now', { ns: 'ui' })}
                </Text>
              )
            }
          </div>
        )
      }
      {
        hasNegative ? (
          <>
            <div
              style={{
                minHeight: `${spacing[0]}%`,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              <Bar
                height={height}
                type={type}
                isTranslucent={!isToday}
                isRounded
                isVisible={amount >= 0}
              />
            </div>
            <div
              style={{
                minHeight: `${spacing[1]}%`,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <Bar
                height={height}
                type={type}
                isTranslucent={!isToday}
                isRounded
                isNegative
                isVisible={amount < 0}
              />
            </div>
          </>
        ) : (
          <Bar
            height={height}
            index={index}
            type={type}
            isTranslucent={!isToday}
            isVisible
          />
        )
      }
    </div>
  );
}
